import { useEffect, useState } from 'react';
import { useTable, useSortBy, useFilters } from 'react-table';
import { FaRegEye } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useFetchData } from '../../../hooks/useFetchData';

function OrderListTable() {
  const { data, loading, error } = useFetchData('mandoub/orders');
  


  const getStatusClass = (status) => {
    switch (status) {
      case 'تم التسليم':
        return 'delivered';
      case 'جاهز للاستلام':
        return 'ready-to-pickup';
      case 'خرج للتوصيل':
        return 'out-for-delivery';
      case 'تم الإرسال':
        return 'dispatched';
      default:
        return 'unknown';
    }
  };

  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  
  useEffect(() => {
    if (data?.orders && data?.orders.length> 0) {
      
      const formattedData = data.orders.map(order => ({
        order: order.orderId,
        date: new Date(order.orderDate).toLocaleString(),
        customer : {
          name: (order?.user?.[0]?.name || "NA"),
          email: (order?.user?.[0]?.email || "NA"), 
          image: (order?.user?.[0]?.image || "/img/default.png"), 
        },        
        payment: order.paymentStatus,
        status: order.status,
        method: order.paymentMethod,
        actions: (order.paymentMethod === "bank" ?(order.paymentStatus === "Paid" ? order._id : false) : order._id), // Use order ID for actions
      }));

      setRows(formattedData);
      console.log(rows);
      
    }

    const selectedColumns = [
      {
        Header: 'الطلب',
        accessor: 'order',
        filterable: true,
        Cell: ({ value }) => (
          <div className="order-id">
            <span>{value}</span>
          </div>
        ),
      },
      {
        Header: 'التاريخ',
        accessor: 'date',
        filterable: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: 'العميل',
        accessor: 'customer',
        filterable: true,
        // Add this filter method
        filter: (rows, id, filterValue) => {
          return rows.filter(row => {
            const customerName = row.values.customer.name.toLowerCase();
            const customerEmail = row.values.customer.email.toLowerCase();
            const searchTerm = filterValue.toLowerCase();
            
            return customerName.includes(searchTerm) || 
                   customerEmail.includes(searchTerm);
          });
        },
        Cell: ({ value }) => (
          <div className="df">
            <div className="order-cus-img">
              <img src={value.image} alt="العميل" />
            </div>
            <div className="df-c g0">
              <div className="bold-1 h-4 leading-none text-right">{value.name}</div>
              <div className="text leading-none h-4 text-xs">{value.email} e</div>
            </div>
          </div>
        ),
      },
      {
        Header: 'الدفع',
        accessor: 'payment',
        filterable: true,
        Cell: ({ value }) => (
          <div className={`mr-4 g0 payment df ${value}`}>
            <div className={`status-dot ${value}`}>
              {value === "Unpaid" ? "غير مدفوع" : value === "Paid" ? "مدفوع" : value}
            </div>
          </div>
        ),
      },
      
      {
        Header: 'الحالة',
        accessor: 'status',
        filterable: true,
        Cell: ({ value }) => (
          <div className={`status df ${getStatusClass(value)}`}>
            <div className={`status ${value.toLowerCase()}`}>
              {value === "Canceled" ? "ملغي" : value === "Pending" ? "قيد الانتظار" : value === "Delivered" ? "تم التسليم" : value}
            </div>
          </div>
        ),
      },
      
      {
        Header: 'طريقة الدفع',
        accessor: 'method',
        filterable: true,
        Cell: ({ value }) => {
          let imgSrc = '';
          switch (value) {
            case "bank":
              imgSrc = 'https://cdn-icons-png.flaticon.com/512/4140/4140809.png';
              break;
            case 'باي بال':
              imgSrc = '/img/paypal.png';
              break;
            case 'ماستر كارد':
              imgSrc = '/img/mastercard.png';
              break;
            default:
              imgSrc = '/img/cash.jpg';
              break;
          }
          return (
            <div className="df method-cell">
              <img src={imgSrc} className='!w-12 !h-12 object-contain'/>
              <span>{value === "bank" ? "تحويل بنكي" : "الدفع عند التسليم"}</span>
            </div>
          );
        },
      },
      {
        Header: 'الإجراء',
        accessor: 'actions',
        Cell: ({ value }) => (
          <div className="x-center df ord--actions">
            {value &&<Link to={`details/${value}`}><FaRegEye /></Link>}
            {!value &&<div>انتظر تأكيد الدفع</div>}
 
          </div>
        ),
      },
    ];

    setColumns(selectedColumns);
  }, [data]);

  const tableInstance = useTable(
    {
      columns,
      data: rows,
    },
    useFilters,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows: tableRows,
    prepareRow,
    setFilter
  } = tableInstance;

  return (
    <div className="section-card df-c " style={{ height: "100vh", width: "100%" }}>
      <div className="title">قائمة طلباتك</div>

      {/* Filtering */}
      <input
        type="text"
        placeholder="ابحث..."
        onChange={e => setFilter('order', e.target.value)}  // Filter by order
      />
      <div style={{ overflow:"scroll", width:"100%", height:"50vh"}}>
      <table {...getTableProps()} className="react-table">
        <thead className='text-right'>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {tableRows.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <td {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>

      </div>
    </div>
  );
}

export default OrderListTable;
